/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [{
  path: 'contacts',
  loadChildren: () => import('./contacts/builder-setup-contacts.module').then(m => m.BuilderSetupContactsModule),
}, {
  path: 'email-templates',
  loadChildren: () => import('./email-templates/builder-setup-email-templates.module').then(m => m.BuilderSetupEmailTemplatesModule),
}, {
  path: 'sms-templates',
  loadChildren: () => import('./sms-templates/builder-setup-sms-templates.module').then(m => m.BuilderSetupSmsTemplatesModule),
}, {
  path: 'estimating',
  loadChildren: () => import('./estimating/builder-setup-estimating.module').then(m => m.BuilderSetupEstimatingModule),
}, {
  path: 'office-permissions',
  loadChildren: () => import('./office-permissions/builder-setup-office-permissions.module').then(m => m.BuilderSetupOfficePermissionsModule),
}, {
  path: 'offices',
  loadChildren: () => import('./offices/builder-setup-offices.module').then(m => m.BuilderSetupOfficesModule),
}, {
  path: 'sub-offices',
  loadChildren: () => import('./sub-offices/builder-setup-sub-offices.module').then(m => m.BuilderSetupSubOfficesModule),
}, {
  path: 'sales',
  loadChildren: () => import('./sales/builder-setup-sales.module').then(m => m.BuilderSetupSalesModule),
}, {
  path: 'system-variables',
  loadChildren: () => import('./system-vars/builder-setup-system-vars.module').then(m => m.BuilderSetupSystemVarsModule),
}, {
  path: 'rfq-structure',
  loadChildren: () => import('./rfq-structure/rfq-structure.module').then(m => m.BuilderSetupRfqStructureModule),
}, {
  path: 'job-admin',
  loadChildren: () => import('./job-admin/builder-setup-job-admin.module').then(m => m.BuilderSetupJobAdminModule),
}, {
  path: 'users',
  loadChildren: () => import('./user-details/builder-setup-user-details.module').then(m => m.BuilderSetupUserDetailsModule),
}, {
  path: 'office-users',
  loadChildren: () => import('./office-users/builder-setup-office-users.module').then(m => m.BuilderSetupOfficeUsersModule),
}, {
  path: 'manager',
  loadChildren: () => import('./manager/builder-setup-manager.module').then(m => m.BuilderSetupManagerModule),
}, {
  path: 'letter-templates',
  loadChildren: () => import('./letter-templates/builder-setup-letter-templates.module').then(m => m.BuilderSetupLetterTemplatesModule),
}, {
  path: 'email-recipients',
  loadChildren: () => import('./email-recipients/builder-setup-email-recipients.module').then(m => m.BuilderSetupEmailRecipientsModule),
}, {
  path: 'scheduling',
  loadChildren: () => import('./scheduling/builder-setup-scheduling.module').then(m => m.BuilderSetupSchedulingModule),
}, {
  path: 'accounting',
  loadChildren: () => import('./accounting/builder-setup-accounting.module').then(m => m.BuilderSetupAccountingModule),
}, {
  path: 'milestone-events',
  loadChildren: () => import('./milestone-events/builder-setup-milestone-events.module').then(m => m.BuilderSetupMilestoneEventsModule),
}, {
  path: 'license-agreements',
  loadChildren: () => import('./license-agreements/builder-setup-license-agreements.module').then(m => m.BuilderSetupLicenseAgreementsModule),
}, {
  path: 'product',
  loadChildren: () => import('./product/builder-setup-product.module').then(m => m.BuilderSetupProductModule),
}, {
  path: 'base-designs',
  loadChildren: () => import('./base-design/builder-setup-base-design.module').then(m => m.BuilderSetupBaseDesignModule),
}, {
  path: 'checklists',
  loadChildren: () => import('./checklists/builder-setup-checklists.module').then(m => m.BuilderSetupChecklistsModule),
}, {
  path: 'report-settings',
  loadChildren: () => import('./report-settings/builder-setup-report-settings.module').then(m => m.BuilderSetupReportSettingsModule),
}, {
  path: 'billing-invoices',
  loadChildren: () => import('./billing-invoices-redirect/builder-setup-billing-invoices-redirect.module').then(m => m.BuilderSetupBillingInvoicesRedirectModule),
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BuilderSetupManagementRoutingModule {
}
